import React from 'react';

import { useState } from 'react';

import { toggleTodo, updateTodo, deleteTodo } from '../redux/actions';
import { useDispatch } from 'react-redux';

const Todo = ({todo}) => {
    //for edit icon ==> initially edit option will remain false but when we'll click on edit pen icon it will become an input field

    const [editing, setEditing] =  useState(false);
    const [text, setText]  = useState(todo.data);

    const dispatch = useDispatch();

    const onFormSubmit = (e) => {
        e.preventDefault(); //to stop reloading of browser

        setEditing(prevState => !prevState);
        
        dispatch(updateTodo(todo._id, text))

    }

    return (
        <li
            className="task"
            onClick={() => dispatch(toggleTodo(todo._id ))}
            style={{
                textDecoration: todo.done ? 'line-through' : '',
                color: todo.done ? '#bdc3c7' : '#34495e'
            }}
        >
            
            <span style={{ display: editing ? 'none' : ''}}>{todo.data}</span>

            <form
                style={{ display: editing ? 'inline' : 'none' }}
                onSubmit={onFormSubmit}
            >
                <input 
                    type="text" 
                    value={text}
                    className="edit-todo"
                    onChange={(e) => setText(e.target.value)}
                />
            </form>
            
            <span className='icon' onClick={() => dispatch(deleteTodo(todo._id))}>
                <i className="fas fa-trash"/>
            </span>
            <span className='icon' onClick={() => setEditing(prevState => !prevState)}>
                <i className="fas fa-pen"/>
            </span>
        </li>
    )
}

export default Todo;